import { Platform, Dimensions } from "react-native";
import DeviceInfo from "react-native-device-info";

export * from "./platform";
export const screenWidth = Dimensions.get("window").width;
export const screenHeight = Dimensions.get("window").height;
export const deviceType = DeviceInfo.getDeviceType();
export const isLargeScreen =
  deviceType === "Tablet" || deviceType === "Desktop" || (deviceType === "unknown" && screenWidth >= 600);
export const os = Platform.OS;
export const agent = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  if (/iphone|ipad|ipod/.test(userAgent)) {
    return "ios";
  } else if (/android/.test(userAgent)) {
    return "android";
  } else {
    return "web";
  }
};
